'use strict'
const u = require('universalify').fromCallback
const mkdirs = u(require('./mkdirs'))
const mkdirsSync = require('./mkdirs-sync')

module.exports = {
  mkdirs,
  mkdirsSync,
  // alias
  mkdirp: mkdirs,
  mkdirpSync: mkdirsSync,
  ensureDir: mkdirs,
  ensureDirSync: mkdirsSync
}



//////////////////
// WEBPACK FOOTER
// ./packages/truffle-compile/~/fs-extra/lib/mkdirs/index.js
// module id = 109
// module chunks = 0 1